
import { useState } from "react";

const useCart = () => {
    const [cart, setCart] = useState([]);
    const [isAddToCard, setIsAddToCard] = useState(false);
  
    const addToCart = (product) => {
      setCart((prev) => {
        const existingProduct = prev.find(
          (item) =>
            item.id === product.id &&
            (!product.size || item.size === product.size)
        );
  
        if (existingProduct) {
          return prev.map((item) =>
            item === existingProduct
              ? { ...item, quantity: item.quantity + 1 }
              : item
          );
        }
  
        return [...prev, { ...product, quantity: 1 }];
      });
      
      setIsAddToCard(true);
        setTimeout(() => {
            setIsAddToCard(false);
        }, 300);
    };

    const removeFromCart = (productId, size) => {
        setCart((prev) => prev.filter((item) => !(item.id === productId && item.size === size)));
    };
  
    const updateQuantity = (productId, size, quantity) => {
      setCart((prev) =>
        prev.map((item) =>
          item.id === productId && item.size === size
            ? { ...item, quantity: Math.max(1, quantity) }
            : item
        )
      );
    };
  
    const clearCart = () => setCart([]);
  
  const getTotal = () => {
    return cart
      .reduce((total, item) => total + item.price * item.quantity, 0)
      .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

    const getQuantity = () => {
        return cart.reduce((quantity, item) => quantity + item.quantity, 0);
    }
  
    return { cart, addToCart, updateQuantity, clearCart, getTotal, removeFromCart, getQuantity, isAddToCard };
  };

  export default useCart;